import React, { useRef, useState } from 'react';
import { translate } from '@utils/i18n';
const namespace = 'features.inspections_attachments';
const MAX_SIZE = 25 * 1024 * 1024;
export function FileDropZone({ file, existingFileName, isCleared, error, onFile, onClear, onError }) {
    const inputRef = useRef(null);
    const [dragging, setDragging] = useState(false);
    const validate = (f) => {
        if (f.type !== 'application/pdf')
            return translate('brushaway.error_pdf_only', { namespace });
        if (f.size > MAX_SIZE)
            return translate('brushaway.error_too_large', { namespace });
        return null;
    };
    const handleChange = (e) => {
        var _a, _b;
        const f = (_b = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : null;
        if (!f)
            return;
        const err = validate(f);
        if (err) {
            onError(err);
            onFile(null);
        }
        else {
            onError(null);
            onFile(f);
        }
    };
    const handleDrop = (e) => {
        e.preventDefault();
        setDragging(false);
        const f = e.dataTransfer.files[0];
        if (!f)
            return;
        const err = validate(f);
        if (err) {
            onError(err);
            onFile(null);
        }
        else {
            onError(null);
            onFile(f);
        }
    };
    const pickedName = file ? file.name : existingFileName;
    const showPicked = !!pickedName && !isCleared;
    if (showPicked) {
        return (React.createElement("div", { className: "dropzone" },
            React.createElement("span", { className: "picked" },
                React.createElement("i", { className: "fa-solid fa-file-lines", "aria-hidden": "true" }),
                pickedName,
                React.createElement("button", { type: "button", className: "qmb-ui-button", "aria-label": "Remove", style: { minWidth: 24, minHeight: 24, padding: 0, marginLeft: 6 }, onClick: file ? () => onFile(null) : onClear },
                    React.createElement("i", { className: "fa-solid fa-xmark", "aria-hidden": "true", style: { fontSize: 11 } })))));
    }
    return (React.createElement("div", { className: `dropzone attachment-dropzone${dragging ? ' is-dragging' : ''}`, onDragOver: (e) => {
            e.preventDefault();
            setDragging(true);
        }, onDragLeave: () => setDragging(false), onDrop: handleDrop, onClick: () => { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, role: "button", tabIndex: 0, onKeyDown: (e) => {
            var _a;
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
            }
        } },
        React.createElement("i", { className: "fa-solid fa-cloud-arrow-up attachment-dropzone__upload-icon", "aria-hidden": "true" }),
        React.createElement("span", { className: "attachment-dropzone__hint" },
            translate('brushaway.drop_hint', { namespace }),
            ' ',
            React.createElement("button", { type: "button", className: "qmb-ui-button qmb-ui-button--highlighted", style: { minHeight: 'auto', padding: '2px 6px' }, onClick: (e) => {
                    var _a;
                    e.stopPropagation();
                    (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
                } }, translate('brushaway.drop_browse', { namespace }))),
        React.createElement("span", { className: "attachment-dropzone__sub-hint" }, translate('brushaway.drop_sub_hint', { namespace })),
        error && React.createElement("span", { className: "attachment-brushaway__error" }, error),
        React.createElement("input", { ref: inputRef, type: "file", accept: ".pdf", className: "attachment-dropzone__input", onChange: handleChange, onClick: (e) => e.stopPropagation() })));
}
